/* CONIUNCTA Dokumentenleiste: Dokumente der gewaehlten Variante bei Variantenwechsel nachfuehren.
   Gehoert zu snippets/coni-dokumente.liquid. Die SKU steckt im Link-Text (z. B. TDS-62046-...), Abgleich nur auf ganze
   Nummern ("-62052-" trifft nicht "-62052-BIO"). Muster (-EM) zeigen die Basis. Bio-Varianten (-BIO, -BIO-EM) zeigen TDS,
   SDS und CDS aus den Bio-Feldern (Index-Typen TDS_BIO/SDS_BIO/CDS_BIO), solange die fehlen die der Basis; CoA immer Basis. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.coniDocsReady) return;
    root.dataset.coniDocsReady = '1';
    var produkt = (document.querySelector('.coni-ia') || { dataset: {} }).dataset.productHandle || '';
    function track(name, params) {
      try {
        window.dataLayer = window.dataLayer || [];
        var ev = { event: name };
        for (var k in params) { if (params[k]) ev[k] = params[k]; }
        window.dataLayer.push(ev);
      } catch (e) { /* Tracking optional */ }
    }
    root.addEventListener('click', function (ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('a') : null;
      if (!a) return;
      if (a.classList.contains('coni-docs__chip--locked') || a.closest('.coni-docs__locked-text')) {
        track('login_aufforderung', { quelle: 'dokumente', produkt: produkt });
      } else if (a.classList.contains('coni-docs__chip') && !a.classList.contains('coni-docs__chip--missing')) {
        var typ = a.dataset.doc === 'COA' ? 'CoA' : a.dataset.doc;
        var sku = ((a.title || '').match(/-(\d{5,})-/) || [])[1] || '';
        track('dokument_download', { dokument: typ, produkt: produkt, sku: sku, datei: a.title || '' });
      }
    });
    var node = root.querySelector('[data-coni-docs="index"]');
    if (!node) return;
    var index = [];
    try { index = JSON.parse(node.textContent) || []; } catch (e) { return; }
    function matchesSku(text, sku) {
      var probe = String(text || '') + '-';
      return probe.indexOf('-' + sku + '-') !== -1 && probe.indexOf('-' + sku + '-BIO') === -1;
    }
    function pick(typ, sku, isBio) {
      var bio = isBio ? index.filter(function (d) { return d.type === typ + '_BIO' && d.url; })[0] : null;
      if (bio) return bio;
      if (typ === 'TDS' || typ === 'COA') {
        return index.filter(function (d) { return d.type === typ && matchesSku(d.text, sku); })[0] || null;
      }
      if (typ === 'SDS') {
        /* R11 (2026-10-17): Pentylen-Variante mit eigenem SDS (custom.sds_3), sonst das SDS des Produkts */
        var pent = index.filter(function (d) { return d.type === 'SDS_PENT' && matchesSku(d.text, sku); })[0];
        if (pent) return pent;
      }
      return index.filter(function (d) { return d.type === typ && d.url; })[0] || null;
    }
    function update(rawSku) {
      if (!rawSku) return;
      var isBio = rawSku.indexOf('-BIO') !== -1;
      var sku = rawSku.replace(/-(BIO|EM)/g, '');
      ['TDS', 'SDS', 'CDS', 'COA'].forEach(function (typ) {
        var chip = root.querySelector('.coni-docs__chip[data-doc="' + typ + '"]');
        if (!chip || chip.classList.contains('coni-docs__chip--missing')) return;
        var hit = pick(typ, sku, typ !== 'COA' && isBio);
        if (hit) { chip.href = hit.url; chip.title = hit.text; }
      });
    }
    try {
      if (window.FoxTheme && FoxTheme.pubsub && typeof FoxTheme.pubsub.subscribe === 'function') {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (e) {
          var d = e && e.data ? e.data : e;
          if (!d || !d.variant) return;
          if (d.sectionId && root.dataset.sectionId && d.sectionId !== root.dataset.sectionId) return;
          update(String(d.variant.sku || ''));
        });
      }
    } catch (e) { /* ohne pubsub bleibt der Stand beim Laden */ }
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.coni-docs'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* PDF-Links einheitlich (Adrian, 24.09.2026: links im Akkordeon gleiches Tab, rechts neues Tab).
   Nielsen Norman Group: Seiten im selben Tab; PDFs auf dem Desktop im neuen Tab, auf dem Handy im selben Tab; Hinweis vorab.
   Betrifft a.coni-doclink (Chips der Dokumentenleiste, Akkordeon "Technische Dokumentation"). Liquid liefert die Desktop-Fassung
   (target=_blank, rel=noopener, aria-describedby "oeffnet in neuem Tab"); auf Touch-Geraeten entfernt dieses Skript target und Hinweis.
   window.ConiDocLinks.apply(true|false) erzwingt einen Modus (Test). */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(hover: none) and (pointer: coarse)') : null;
  function isTouch() { return !!(mq && mq.matches); }
  function apply(touch) {
    if (typeof touch !== 'boolean') touch = isTouch();
    Array.prototype.forEach.call(document.querySelectorAll('a.coni-doclink'), function (a) {
      if (touch) {
        if (a.getAttribute('target') === '_blank') a.removeAttribute('target');
        var d = a.getAttribute('aria-describedby');
        if (d) { a.dataset.coniNewtab = d; a.removeAttribute('aria-describedby'); }
      } else {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
        if (a.dataset.coniNewtab && !a.getAttribute('aria-describedby')) a.setAttribute('aria-describedby', a.dataset.coniNewtab);
      }
    });
  }
  // Sicherheitsnetz fuer spaeter gerenderte Links: auf Touch-Geraeten beim Tippen im selben Tab bleiben.
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a.coni-doclink') : null;
    if (a && isTouch() && a.getAttribute('target') === '_blank') a.removeAttribute('target');
  }, true);
  if (mq && mq.addEventListener) mq.addEventListener('change', function () { apply(); });
  window.ConiDocLinks = { apply: apply };
  function boot() { apply(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  try {
    if (window.FoxTheme && FoxTheme.pubsub && typeof FoxTheme.pubsub.subscribe === 'function') {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function () { window.setTimeout(boot, 300); });
    }
  } catch (e) { /* ohne pubsub reicht der Klick-Fallback */ }
})();
